export const decode = (value: string): string => {
    // Use textarea for as an intermediate step for decoding html entities,
    // avoiding large packages like html-entities that bloat the bundle size.
    //
    // There's no significant performance overhead with this, since we only decode
    // values when the popup is actually shown (user clicks a poi).
    const textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    return textArea.value;
};
